/**
 * Entry exports for AI country result card chrome.
 */

import { cn } from '@/lib/utils';
import type { DropLabel } from '@/features/campaign-texts/components/PerDropGroupSelector';
import type { TreeGroupLike } from '@/features/campaign-texts/utils/group-tree.utils';

import type { CountryGenResult } from '../../shared/multiCountryBulkEdit.types';

import type { AiTextPickInteraction } from './aiTextPickInteraction.types';
import { FlatContent, PerDropGroupedContent } from './countryResultLayouts';

export type { AiTextPickInteraction } from './aiTextPickInteraction.types';

export function CountBadge({ icon, count, color }: { icon: React.ReactNode; count: number; color: 'blue' | 'green' }) {
  const cls = color === 'blue' ? 'bg-blue-500/10 text-blue-600' : 'bg-green-500/10 text-green-600';
  return (
    <span className={cn('flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[10px]', cls)}>
      {icon} {count}
    </span>
  );
}

export function CountryResultContent({
  result,
  dropLabels,
  promptGroups,
  textPickInteraction,
}: {
  result: CountryGenResult;
  dropLabels?: DropLabel[];
  promptGroups?: TreeGroupLike[];
  textPickInteraction?: AiTextPickInteraction;
}) {
  const hasPerDrop = (result.textBatches?.length ?? 0) > 0 || (result.senderBatches?.length ?? 0) > 0;
  return (
    <div className="min-w-0">
      {hasPerDrop ? (
        <PerDropGroupedContent
          result={result}
          dropLabels={dropLabels}
          promptGroups={promptGroups}
          textPickInteraction={textPickInteraction}
        />
      ) : (
        <FlatContent result={result} textPickInteraction={textPickInteraction} />
      )}
    </div>
  );
}
